/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_5_TitleInputs */

const en_terms_section_5_title = /** @type {(inputs: Terms_Section_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Intellectual Property`)
};

const lv_terms_section_5_title = /** @type {(inputs: Terms_Section_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Intelektuālais īpašums`)
};

/**
* | output |
* | --- |
* | "5. Intellectual Property" |
*
* @param {Terms_Section_5_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_5_title = /** @type {((inputs?: Terms_Section_5_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_5_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_5_title(inputs)
	return en_terms_section_5_title(inputs)
});